import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ShivaPublicInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(environment.publicApiUrl)) {
      const modifiedReq = request.clone({
        setHeaders: { KeyId: environment.apiKeyPublic },
      });
      return next.handle(modifiedReq);
    }
    return next.handle(request);
  }
}
